<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">Trinka 點數</h1>
                        <h2>依需求靈活使用各種功能</h2>
                        <p>點數就像代幣，讓你依需求使用不同 Trinka 功能。
                            基本方案用戶可獲得 4 點免費點數<br/>
                            高級方案用戶可獲得 10 點免費點數
                        </p>
                        <div class="btn-group">
                            <a href="https://cloud.trinka.ai/signup?_rg=TW" class="filled-btn" target="_blank">開始使用</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/features/credits/CreditInformation.webp" width="460" height="360" alt="credit info" class="md50" priority />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pt-0">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>立即開始使用點數功能</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="credit_feature">
                    <table class="table">
                        <thead>
                            <tr class="odd">
                                <th>特徵</th>
                                <th class="text-center">
                                    <small>
                                        <img src="/assets/images/credits_icon.png" width="26" height="22" alt="icon" />
                                    </small> 消耗的積分
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <h5>標準抄襲檢查</h5>
                                    <small>
                                        針對網路資源與部分開放取用期刊進行高品質比對
                                    </small>
                                </td>
                                <td>
                                    <p class="text-center">每份報告 12 個點數
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td class="odd">
                                    <h5>高級方案抄襲檢查</h5>
                                    <small>
                                        包含網路資源、開放取用與付費出版物
                                    </small>
                                </td>
                                <td class="odd">
                                    <p class="text-center">
                                        每份報告 18 個點數
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>文件校稿</h5>
                                    <small>自動編輯 Word 文件，下載帶修訂記錄的檔案
                                    </small>
                                </td>
                                <td>
                                    <p class="text-center">
                                        每 5000 字 1 個點數
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td class="odd">
                                    <h5>技術審查</h5>
                                    <small>
                                        依超過20項標準檢查出版合規性（如期刊選擇、倫理遵守等）
                                    </small>
                                </td>
                                <td class="odd">
                                    <p class="text-center">
                                        每份報告 1 個點數
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <h5>引文檢查器</h5>
                                    <small>
                                        發現薄弱引用，建議可靠文獻提升論述品質
                                    </small>
                                </td>
                                <td>
                                    <p class="text-center">
                                        每 30 筆引文 1 個點數
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td class="odd">
                                    <h5>引文格式整理器</h5>
                                    <small>
                                        快速套用各大引文格式、校對與標準化
                                    </small>
                                </td>
                                <td class="odd">
                                    <p class="text-center">
                                        每 30 筆引文 1 個點數
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="credits_availability section-pd bg-light-purple">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>點數有效期限與使用規則</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100">所有用戶每 30 天獲得免費點數（自註冊日計算）</p>
                    <p class="w-100">可依需求加購點數，購買的點數永久有效。如需了解各種點數方案，<a class="text-link" (click)="scroll(target)">請點此查看。</a></p>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 col-sm-6 dflex">
                <div class="c-card">
                    <h2>基本方案用戶</h2>
                    <span>免費用戶</span>
                    <h3>4</h3>
                    <p>(每 30 天贈送免費點數)</p>
                </div>
            </div>
            <div class="col-lg-6 col-sm-6 dflex">
                <div class="c-card">
                    <h2>高級方案用戶</h2>
                    <span>付費用戶</span>
                    <h3>10</h3>
                    <p>(每 30 天贈送免費點數)</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="how_it_works section-pd">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center">
                    <h2>如何使用</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>以下是使用基本用戶方案的用戶在 1 月 5 日註冊後的使用情境範例：
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="credit_case">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th colspan="5">範例 1 基本方案用戶（未購點）</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>日期</td>
                                    <td>說明</td>
                                    <td>使用</td>
                                    <td>增加</td>
                                    <td>餘額</td>
                                </tr>
                                <tr>
                                    <td>1/5</td>
                                    <td>免費點數餘額	</td>
                                    <td></td>
                                    <td></td>
                                    <td>4</td>
                                </tr>
                                <tr>
                                    <td>1/10</td>
                                    <td>使用 1 點進行文件校稿	</td>
                                    <td style="color: red;">-1</td>
                                    <td></td>
                                    <td>3</td>
                                </tr>
                                <tr>
                                    <td>2/5</td>
                                    <td>免費點數重置</td>
                                    <td style="color: red;"></td>
                                    <td style="color: green;">+4</td>
                                    <td>4</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="credit_case">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th colspan="5">範例 2｜基本方案用戶（有購點）</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>日期</td>
                                    <td>說明</td>
                                    <td>使用</td>
                                    <td>增加</td>
                                    <td>餘額</td>
                                </tr>
                                <tr>
                                    <td>1/5</td>
                                    <td>免費點數餘額</td>
                                    <td></td>
                                    <td></td>
                                    <td>4</td>
                                </tr>
                                <tr>
                                    <td>1/10</td>
                                    <td>使用 2 點進行文件校稿</td>
                                    <td style="color: red;">-2</td>
                                    <td></td>
                                    <td>2</td>
                                </tr>
                                <tr>
                                    <td>1/25</td>
                                    <td>購買 2 點</td>
                                    <td></td>
                                    <td style="color: green;">+2</td>
                                    <td>4</td>
                                </tr>
                                <tr>
                                    <td>2/5</td>
                                    <td>免費點數重置（保留付費點數）</td>
                                    <td></td>
                                    <td style="color: green;">+4</td>
                                    <td>6</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="credit_case">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th colspan="5">範例 3｜高級方案用戶</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>日期</td>
                                    <td>說明</td>
                                    <td>使用</td>
                                    <td>增加</td>
                                    <td>餘額</td>
                                </tr>
                                <tr>
                                    <td>1/5</td>
                                    <td>免費點數餘額</td>
                                    <td></td>
                                    <td></td>
                                    <td>10</td>
                                </tr>
                                <tr>
                                    <td>1/25</td>
                                    <td>購買 2 點 </td>
                                    <td></td>
                                    <td style="color: green;">+2</td>
                                    <td>12</td>
                                </tr>
                                <tr>
                                    <td>1/25</td>
                                    <td>使用 4 點進行文件校稿 </td>
                                    <td style="color: red;">-4</td>
                                    <td></td>
                                    <td>8</td>
                                </tr>
                                <tr>
                                    <td>2/5</td>
                                    <td>免費點數重置（保留付費點數）</td>
                                    <td></td>
                                    <td style="color: green;">+10</td>
                                    <td>12</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <small style="position: absolute; bottom: -35px; left: 0;">* 免費點數每月到期便會自動重置</small>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="credit_balance section-pd">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h2>點數餘額</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="credit_balance_wrapper">
                    <div class="credit_balance_inner">
                        <img src="/assets/images/features/credits/credits-banner1.webp" width="500" height="283" alt="credit-banner" class="img-fluid" />
                    </div>
                    <div class="credit_balance_text">
                        <div class="credit_table">
                            <h3>查詢與購買點數</h3>
                            <p>點數餘額會顯示於所有相關頁面，點擊餘額可查看詳情與立即購買。</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="credit_balance_wrapper">
                    <div class="credit_balance_inner">
                        <img src="/assets/images/features/credits/credits-banner2.webp" width="500" height="241" alt="credit-banner" class="img-fluid" />
                    </div>
                    <div class="credit_balance_text">
                        <div class="credit_table">
                            <h3>使用 Trinka 功能所需點數</h3>
                            <p>在使用需要點數的功能前，系統會清楚顯示該功能所需的點數數量，讓你放心使用。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd buy_credits">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>購買點數</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>你可以隨時依需求加購點數包。點數包讓你一次購買多點，靈活運用、隨時可用。</p>
                    <p>購買的點數永久有效，不會過期，還可享有超值折扣優惠。系統會自動優先使用免費點數，幫你節省更多！</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="credit_feature">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr class="odd">
                                    <th>點數包</th>
                                    <th class="text-center">基本用戶</th>
                                    <th class="text-center">高級用戶</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <h5>每月免費點數</h5>
                                    </td>
                                    <td><p class="text-center">4 點</p></td>
                                    <td><p class="text-center">10 點</p></td>
                                </tr>
                                <tr>
                                    <td><h5>{{decodedData[0].text}}</h5></td>
                                    <td>
                                        <div class="credit_info">
                                            <sup>{{decodedData[0].currency_code}}</sup> 
                                            {{decodedData[0].final_amount / 2 | number:'1.2-2'}}
                                            <i>per credit</i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[0].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[0].currency_code}}</sup> {{calculatePlan(premiumDecodedData[0].final_amount, premiumDecodedData[0].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[3].final_amount, decodedData[3].months)}}% off</span>
                                            <i>{{premiumDecodedData[0].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><h5>{{decodedData[1].text}}</h5></td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[1].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[1].currency_code}}</sup> {{calculatePlan(decodedData[1].final_amount, decodedData[1].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[1].final_amount, decodedData[1].months)}}% off</span>
                                            <i>{{decodedData[1].amount_suffix}}</i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[1].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{premiumDecodedData[1].currency_code}}</sup> {{calculatePlan(premiumDecodedData[1].final_amount, premiumDecodedData[1].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,premiumDecodedData[1].final_amount, premiumDecodedData[1].months)}}% off</span>
                                            <i>{{premiumDecodedData[1].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><h5>{{decodedData[2].text}}</h5></td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[2].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[2].currency_code}}</sup> {{calculatePlan(decodedData[2].final_amount, premiumDecodedData[2].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[2].final_amount, decodedData[2].months)}}% off</span>
                                            <i>{{decodedData[2].amount_suffix}}</i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[2].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{premiumDecodedData[2].currency_code}}</sup> {{calculatePlan(premiumDecodedData[2].final_amount, premiumDecodedData[2].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,premiumDecodedData[2].final_amount, premiumDecodedData[2].months)}}% off</span>
                                            <i>{{premiumDecodedData[2].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><h5>{{decodedData[3].text}}</h5></td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[3].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[3].currency_code}}</sup> {{calculatePlan(decodedData[3].final_amount, premiumDecodedData[3].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[3].final_amount, decodedData[3].months)}}% off</span>
                                            <i>{{decodedData[3].amount_suffix}}</i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[3].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{premiumDecodedData[3].currency_code}}</sup> {{calculatePlan(premiumDecodedData[3].final_amount, premiumDecodedData[3].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,premiumDecodedData[3].final_amount, premiumDecodedData[3].months)}}% off</span>
                                            <i>{{premiumDecodedData[3].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                                
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-11">
                <div class="trinka-title text-center">
                    <h3 class="text-white mb-4">團隊與企業用戶點數方案</h3>
                    <p class="text-white mt-20">Trinka 企業方案提供團隊與機構量身訂製的點數購買與分配方式，支援靈活的點數管理與大量採購。</p>
                </div>
                <div class="btn-group justify-content-center">
                    <a [routerLink]="['/enterprise']" routerLinkActive="active" class="white-btn">聯繫我們</a>
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        購買的點數可以退費嗎？
                                    </a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>購買的點數無法退費，但會永久保留，可隨時使用。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">升級成 高級方案後，原有免費點數會怎樣？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>升級後免費點數會重設為 10 點，先前未使用的免費點數將不保留。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        如果我升級為高級方案，原方案購買的點數會怎樣？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>升級後，你先前購買的點數會保留在帳戶中，隨時都可以使用，完全不受影響。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        購買點數有數量限制嗎？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>沒有，你可以依需求購買任意數量的點數，沒有購買上限。
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
